module.exports = __webpack_public_path__ + "static/media/pic7.59e8f1fc.png";